import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IAttachment } from 'src/app/model/attachments/iattachment';
import { PAGE_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { ATTACHMENT_FORM_DEF } from 'src/app/service/ansokan-form-builder/form-definitions';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';

@Component({
    selector: 'app-attachment-selector',
    styleUrls: ['./attachment-selector.component.scss'],
    templateUrl: './attachment-selector.component.html',
    standalone: false
})
export class AttachmentSelectorComponent implements OnInit {

  public readonly NEW_ATTACHMENT = '#ADD_NEW_ATTACHMENT#';
  public readonly SEND_BY_MAIL = '#SEND_ATTACHMENT_BY_MAIL#';
  private readonly MIN_FILE_SIZE: number = 2 * 1024 * 1024; // 2 MB
  private readonly MAX_FILE_SIZE: number = 5 * 1024 * 1024; // 5 MB
  @Input() public isSupplement: boolean = false;
  public uploadErrors: string[];
  @ViewChild('fileInput')
  private fileInput: ElementRef;
  private attachmentsGroup: UntypedFormGroup;

  constructor(
    private service: AnsokanFormGroupService,
    private fb: UntypedFormBuilder,
    private change: ChangeDetectorRef,

  ) { }

  public get attachmentValues(): IAttachment[] {
    return this.attachments ? this.attachments.controls.map((group: UntypedFormGroup) => group.value) as IAttachment[] : [];
  }

  private get attachments(): UntypedFormArray {
    return this.attachmentsGroup.get(PAGE_NAMES.ATTACHMENTS.ATTACHMENTS.KEY) as UntypedFormArray;
  }

  public ngOnInit() {
    this.attachmentsGroup = this.service.get(PAGE_NAMES.ATTACHMENTS.KEY) as UntypedFormGroup;
  }

  public openFileExplorer(): void {
    this.uploadErrors = null;
    this.fileInput.nativeElement.click();
  }

  public onFileSelect(files: FileList) {
    if (files && files.length) {
      const reader = new FileReader();
      const file: File = files.item(0);
      this.uploadErrors = this.validate(file);
      if (this.uploadErrors.length === 0) {
        reader.onload = () => this.addAttachment(file, reader.result as string);
        reader.readAsBinaryString(file);
      }
    }
    this.fileInput.nativeElement.value = '';
  }

  public deleteAttachment(index: number): void {
    this.attachments.removeAt(index);
  }

  private addAttachment(file: File, binaryContent: string): void {
    // Create attachments from file.
    const base64Content = btoa(binaryContent);
    const attachment = {
      content: base64Content,
      fileName: file.name,
      size: file.size,
    };
    // Create form group.
    const group: UntypedFormGroup = this.fb.group(ATTACHMENT_FORM_DEF);
    group.patchValue(attachment);
    // Add form group to attachments.
    this.attachments.push(group);
    this.change.detectChanges();
  }

  private validate(file: File): string[] {
    // Validate and return an array of any errors.
    const errors = [];
    // Check file type is pdf.
    if (file.type !== 'application/pdf') {
      errors.push('Endast dokument av typen PDF är tillåtet');
    }
    // Check file size does not exced max.
    if (this.isSupplement && file.size > this.MAX_FILE_SIZE) {
      errors.push('Filen är större än 5 MB och kan inte laddas upp');
    } else if (!this.isSupplement && file.size > this.MIN_FILE_SIZE) {
                 errors.push('Filen är större än 2 MB och kan inte laddas upp');
    }
    // Check file is not already added.
    this.attachmentValues
      .filter((att: IAttachment) => att.fileName === file.name)
      .forEach(() => errors.push('Dokumentet finns redan bifogat'));
    return errors;
  }
}
